module.exports = __webpack_public_path__ + "static/media/dr-lokuketagoda.27b797e6.jpg";